import { httpRequest } from '../util/api-common.util';

class NotasAPI {
  static listarNotas(laudo) {
    return httpRequest(`laudos/notas/${laudo}`);
  }
}

export default NotasAPI;



// WEBPACK FOOTER //
// ./src/app/common/multinotas/multinotas.api.js